/*!
 * Copyright 2023 Quisitive Technologies, LLC. All rights reserved.
 */
import React, { useEffect } from 'react';

import { get, values } from 'lodash';
import Element from '../../../../components/element';
import Flex from '../../../../components/flex';
import Text from '../../../../components/text';
import NoData from '../../NoData';
import { create, updateData } from '../../Chart/DistributionChart/chart';

const Strength = ({ healthReportData }) => {
  useEffect(() => {
    const dexterityList = values(healthReportData.strength);
    dexterityList.map(each => {
      const data = { ...each, section: 'dexterity', chartVal: each.value };
      const settings = {
        el: each.display_label.replace(/ /g, '_'),
        margin: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0
        }
      };
      create(settings);
      updateData(data);
    });
  }, []);
  return (
    <Element>
      {get(healthReportData, 'strength.dominant.value') === null &&
        get(healthReportData, 'strength.non_dominant.value') === null ? (
        <NoData />
      ) : (
        <Element>
          <Element>
            <Text family="GTAM" size="14px" color="#222222" width="830px">
              Strength is the capacity of a muscle to produce the tension and
              power necessary for maintaining posture, initiating movement, or
              controlling movement. Grip Strength is a good indicator of overall
              strength and is highly predictive of future functional limitations
              and disability.
            </Text>
          </Element>
          <Flex align="center" marginTop="50px">
            <Element width="250px">
              <Text
                family="GTAM"
                size="16px"
                color="#222222"
                marginBottom="30px"
              >
                Dominant Hand
              </Text>
            </Element>
            <Element marginRight="70px">
              <Text
                family="GTAM"
                size="24px"
                color="#222222"
                marginBottom="0px"
              >
                {/* {Number(
                  get(healthReportData, 'strength.dominant.percentile')
                ).toFixed(2)}
                % */}
                {Math.floor(
                  Number(
                    get(healthReportData, 'strength.dominant.percentile')
                  ) * 10
                ) /
                  10 +
                  '%' || 0 + '%'}
              </Text>
              <Text family="GTAR" size="14px" color="#959595" marginTop="0px">
                Percentile
              </Text>
            </Element>
            <div
              id={get(
                healthReportData,
                'strength.dominant.display_label'
              ).replace(/ /g, '_')}
              style={{ width: '25.58%' }}
            ></div>
          </Flex>
          <Flex align="center" marginTop="70px">
            <Element width="250px">
              <Text
                family="GTAM"
                size="16px"
                color="#222222"
                marginBottom="30px"
              >
                Non-Dominant Hand
              </Text>
            </Element>
            <Element marginRight="70px">
              <Text
                family="GTAM"
                size="24px"
                color="#222222"
                marginBottom="0px"
              >
                {/* {Number(
                  get(healthReportData, 'strength.non_dominant.percentile')
                ).toFixed(2)}
                % */}
                {Math.floor(
                  Number(
                    get(healthReportData, 'strength.non_dominant.percentile')
                  ) * 10
                ) /
                  10 +
                  '%' || 0 + '%'}
              </Text>
              <Text family="GTAR" size="14px" color="#959595" marginTop="0px">
                Percentile
              </Text>
            </Element>
            <div
              id={get(
                healthReportData,
                'strength.non_dominant.display_label'
              ).replace(/ /g, '_')}
              style={{ width: '25.58%' }}
            ></div>
          </Flex>
        </Element>
      )}
    </Element>
  );
};

export default Strength;
